import { AlertCircle, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type QueryErrorProps = {
	onRetry?: () => void;
	className?: string;
	compact?: boolean;
};

export function QueryError({ onRetry, className, compact }: QueryErrorProps) {
	const { t } = useTranslation();

	return (
		<div
			role="alert"
			className={cn(
				"flex flex-col items-center justify-center gap-2 text-center",
				compact ? "p-4" : "p-8",
				className,
			)}
		>
			<AlertCircle
				aria-hidden="true"
				className={cn("text-destructive", compact ? "size-5" : "size-8")}
			/>
			<p className="text-sm font-medium text-foreground">
				{t("queryError.title")}
			</p>
			{!compact && (
				<p className="text-xs text-muted-foreground">
					{t("queryError.description")}
				</p>
			)}
			{onRetry && (
				<Button
					variant="outline"
					size={compact ? "xs" : "sm"}
					onClick={onRetry}
					className="mt-1"
				>
					<RefreshCw aria-hidden="true" className="size-3.5" />
					{t("queryError.retry")}
				</Button>
			)}
		</div>
	);
}
